import _freeGlobal_default from "./_freeGlobal.js";

//#region ../../node_modules/lodash-es/_root.js
/** Detect free variable `self`. */
var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */
var root = _freeGlobal_default || freeSelf || Function("return this")();
var _root_default = root;

//#endregion
export { _root_default as default };
//# sourceMappingURL=_root.js.map